export { default as eventRegistry } from './eventRegistry';
